import React, { useState } from "react";
import { Hero, SearchForm, FeaturesCarousel } from '../components';
import { User, defaultUser, Search } from '../models';
import { getUsers } from '../services';

export interface FrontPageProps {
    initialState: FrontPageState;
    searchAgeMin: number;
    searchAgeMax: number;
    onlineMembers: number;
    onlineMembersLast7Days: number;
}

export interface FrontPageState {
    loading: boolean;
    search: Search;
    hero: User[];
}

export const fillEmptyPhotos = (state: FrontPageState): FrontPageState => {
    return {
        ...state,
        hero: [...state.hero, ...Array(6).fill(defaultUser)].slice(0, 6) as User[],
    };
};

export const FrontPage = ({ initialState, searchAgeMin, searchAgeMax, onlineMembers, onlineMembersLast7Days }: FrontPageProps) => {
    const [state, setState] = useState<FrontPageState>(fillEmptyPhotos(initialState));

    return <div className="app-paz-block app-flex">
        <h1><a href="//pazintys.draugas.lt">Populiariausia pažinčių svetainė Lietuvoje!</a></h1>
        <Hero
            users={state.hero}
            loading={state.loading} />
        <div className="app-paz-right">
            <FeaturesCarousel onlineMembers={onlineMembers} onlineMembersLast7Days={onlineMembersLast7Days} />
            <SearchForm search={state.search}
                ageMin={searchAgeMin}
                ageMax={searchAgeMax}
                onChange={(search) => {
                    Promise.all([getUsers(search)])
                        .then(([newState]) => {
                            return {
                                ...newState,
                            };
                        }).then(fillEmptyPhotos).then(setState);
                }} />
        </div>
    </div>;
};